import { RtKey } from "src/components/ReactiveTable/RtTypes";
import { ZOption, ZSidLabel } from "src/types";

/**
 * Генератор опций для RtSelection
 * Нам нужно показывать опции в виде {value, label}
 * RtSore для выбранных строк реально хранит только ключи, т.е. RtStore.selectedKeys
 * Для labels организуется специальный кеш, который изначально заполняется из initial
 * Известно, что в момент нажатия на radio или checkbox, строка находится на текущей странице и из неё можно получить label.
 * Этот label сохраняется в тот же кеш.
 * Таким образом, у нас есть возможность показывать {value, label} для тех ключей,
 * которые были хотя бы раз кликнуты. Даже если содержимое страницы поменялось.
 *
 * Экземпляр optionsMaker внутри компонента нужно хранить в сторе, или при помощи useRef
 *
 * @param initial исходное значение в виде списка ZSidLabel[]
 * @param getLabel получение label из строки
 */
export const optionsMaker = <TRow>(
  initial: ZSidLabel[],
  getLabel: (row: TRow) => string | null | undefined,
) => {
  const cache: Record<string, string> = {};
  initial.forEach(({ id, label }) => {
    cache[id] = label;
  });
  const makeLabel = (key: RtKey, row?: TRow): string => {
    if (row) {
      const label = getLabel(row);
      if (label) {
        cache[key] = label;
        return label;
      }
    }
    const cached = cache[key];
    if (cached) return cached;
    return String(key);
  };
  return (key: RtKey, row?: TRow) => ({
    value: String(key),
    label: makeLabel(key, row),
  });
};

export const makeSidLabelsFromKeys = (
  keys: RtKey[],
  makeOption: (key: RtKey) => ZOption,
): ZSidLabel[] =>
  keys
    .map((key) => makeOption(key))
    .map(({ value, label }) => ({ id: value, label }));
